import { createContext } from 'react';

export interface TitleState {
  firmOrCompanyName: string;
  pageName: string;
  measurementDate: string;
}

export interface TitleContextType extends TitleState {
  updateTitle: (key: keyof TitleState, value: string) => void;
  updateMultiple: (updates: Partial<TitleState>) => void;
  resetTitle: () => void;
}

export const TitleContext = createContext<TitleContextType>({
  firmOrCompanyName: '',
  pageName: '',
  measurementDate: '',
  updateTitle: () => {},
  updateMultiple: () => {},
  resetTitle: () => {},
});
